module.exports = __webpack_public_path__ + "static/media/bg.c0931f28.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg.png
// module id = 1362
// module chunks = 0